export function getAccessTokenUsecaseFactory(deps) {
    return async () => {
        return (await deps.authRepository.getUserAuth0Token()).accessToken;
    };
}
//# sourceMappingURL=get-access-token.usecase.js.map